import SectionLabel from "@/components/base/SectionLabel";
import { pricingData } from "@/mocks/pricingData";

export default function ScopeSection() {
  return (
    <section id="scope" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel label={pricingData.scope.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {pricingData.scope.title}
          </h2>
        </div>

        {/* Monthly pricing scope note */}
        <div className="reveal max-w-3xl mx-auto mb-8">
          <div className="flex items-start gap-2.5 px-4 py-3.5 rounded-md bg-accent-50 border border-accent-200/60">
            <i className="ri-information-line text-accent-600 mt-0.5 flex-shrink-0" />
            <p className="text-xs md:text-sm text-foreground-700 leading-relaxed">
              {pricingData.scope.monthlyNote}
            </p>
          </div>
        </div>

        <div className="reveal grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 mb-8">
          {/* Included */}
          <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
            <div className="flex items-center gap-2.5 mb-5">
              <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-check-line text-primary-600" />
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900">
                {pricingData.scope.included.title}
              </h3>
            </div>
            <ul className="space-y-2.5">
              {pricingData.scope.included.items.map((item, i) => (
                <li key={i} className="flex items-start gap-2.5">
                  <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0" />
                  <span className="text-sm md:text-base text-foreground-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Excluded */}
          <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
            <div className="flex items-center gap-2.5 mb-5">
              <div className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-subtract-line text-secondary-600" />
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900">
                {pricingData.scope.excluded.title}
              </h3>
            </div>
            <ul className="space-y-2.5">
              {pricingData.scope.excluded.items.map((item, i) => (
                <li key={i} className="flex items-start gap-2.5">
                  <i className="ri-close-line text-secondary-500 mt-0.5 flex-shrink-0" />
                  <span className="text-sm md:text-base text-foreground-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom note - emphasized */}
        <div className="reveal text-center">
          <div className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-accent-50 border border-accent-200/60">
            <i className="ri-information-line text-accent-600 text-lg" />
            <p className="text-sm md:text-base font-medium text-accent-800">
              {pricingData.scope.note}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}